import script from "./RoomItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./RoomItem.vue?vue&type=script&lang=ts&setup=true"

import "./RoomItem.vue?vue&type=style&index=0&id=3f91eb65&lang=css"

const __exports__ = script;

export default __exports__